<template>
  <v-row
    v-if="managementToken || isDevelopment"
    class="ma-0 pa-0 pa-4 vetalfa-background vetalfa-row"
  >
    <v-row
      v-show="!topicsManagementModel"
      class="ma-0 pa-0"
      id="topics-management-edition-row"
    >
      <v-col cols="12">
        <v-card height="60px">
          <v-row class="ma-0 pa-0 vetalfa-row" align="center" justify="start">
            <v-col
              cols="2"
              class="ma-0 pa-0 ml-2"
              v-if="!item || !subtopic || !topic || !configuration"
            >
              <v-btn
                @click="openTopicSelection()"
                color="primary"
                class="text-none"
                block
              >
                Gestão de Tópicos
              </v-btn>
            </v-col>
            <v-col
              cols="2"
              class="ma-0 pa-0 ml-2"
              v-if="
                ([1, 3].includes(profile) || isDevelopment) &&
                (!item || !subtopic || !topic || !configuration)
              "
            >
              <v-btn to="/categories" color="primary" class="text-none" block>
                Gestão de Categorias
              </v-btn>
            </v-col>
            <v-col
              cols="2"
              class="ma-0 pa-0 ml-2"
              v-if="
                ([1].includes(profile) || isDevelopment) &&
                (!item || !subtopic || !topic || !configuration)
              "
            >
              <v-btn to="/customers" color="primary" class="text-none" block>
                CRM
              </v-btn>
            </v-col>
            <v-col
              class="ma-0 pa-0 px-2"
              cols="1"
              v-if="item && subtopic && topic && configuration"
            >
              <v-row class="ma-0 pa-0" align="center">
                <v-btn
                  @click="openTopicSelection()"
                  color="primary"
                  block
                  class="text-none"
                >
                  <v-icon>{{ mdiFileTree }}</v-icon>
                </v-btn>
              </v-row>
            </v-col>
            <v-col
              class="ma-0 pa-0"
              cols="5"
              v-if="item && subtopic && topic && configuration"
            >
              <v-row class="ma-0 pa-0" align="start" justify="start">
                <v-col class="ma-0 pa-0" cols="12">
                  <p class="ma-0 pa-0">
                    <v-textarea
                      rows="1"
                      type="text"
                      hide-details
                      auto-grow
                      class="ma-0 pa-0"
                      light
                      dense
                      color="primary"
                      v-model="item.name"
                    ></v-textarea>
                    <span
                      class="vetalfa-subtitle"
                      v-if="profile == 1 || isDevelopment"
                    >
                      {{ `(${item.id})` }}
                    </span>
                  </p>
                </v-col>
              </v-row>
            </v-col>
            <v-spacer></v-spacer>
            <v-col v-if="item && subtopic && topic && configuration" cols="1">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    block
                    color="primary"
                    class="text-none"
                    v-bind="attrs"
                    v-on="on"
                    @click="classesAndAnimalsModel = true"
                  >
                    <v-icon>{{ mdiFilterVariant }}</v-icon>
                  </v-btn>
                  <vetalfa-dialog
                    id="classesAndAnimalsModel"
                    :title="'Classificações'"
                    :toggleModel="classesAndAnimalsModel"
                    v-on:dialogClose="classesAndAnimalsModel = false"
                  >
                    <vetalfa-section-title
                      prop="Classes | Categorias do item"
                      v-if="item"
                      class="ma-0 pa-0"
                    >
                      <v-combobox
                        :items="categoriesList"
                        label="Digite e pressione enter para criar novos registros"
                        hide-details
                        return-object
                        filled
                        class="my-5 mx-2"
                        dense
                        small-chips
                        outlined
                        multiple
                        v-model="categories"
                        clearable
                      >
                      </v-combobox>
                    </vetalfa-section-title>
                    <vetalfa-section-title
                      prop="Sinônimos"
                      v-if="item"
                      class="ma-0 pa-0"
                    >
                      <v-combobox
                        :items="[]"
                        label="Digite e pressione enter para criar novos registros"
                        hide-details
                        return-object
                        filled
                        class="my-5 mx-2"
                        dense
                        small-chips
                        outlined
                        multiple
                        v-model="synonyms"
                        clearable
                      >
                      </v-combobox>
                    </vetalfa-section-title>
                    <vetalfa-section-title
                      prop="Animais associados ao item"
                      v-if="item"
                      class="ma-0 pa-0"
                    >
                      <v-select
                        v-model="animals"
                        :items="[
                          { value: 1, text: 'Cães' },
                          { value: 2, text: 'Gatos' },
                        ]"
                        item-value="value"
                        small-chips
                        class="my-5 mx-2"
                        item-text="text"
                        label="Selecione os animais associados"
                        dense
                        multiple
                        outlined
                        clearable
                      ></v-select>
                    </vetalfa-section-title>
                    <!-- <vetalfa-section-title
                      prop="Pontuação Volume Conteúdo Cumulativo"
                      v-if="item && (profile == 1 || isDevelopment)"
                      class="ma-0 pa-0"
                    >
                      <v-textarea
                        auto-grow
                        rows="1"
                        type="text"
                        inputmode="decimal"
                        hide-details
                        class="my-5 mx-2"
                        light
                        dense
                        label="Pontuação"
                        color="primary"
                        v-model="contentPoints.value"
                        outlined
                      ></v-textarea>
                      <v-textarea
                        auto-grow
                        rows="1"
                        type="text"
                        hide-details
                        class="my-5 mx-2"
                        light
                        label="Descritivo"
                        dense
                        color="primary"
                        v-model="contentPoints.description"
                        outlined
                      ></v-textarea>
                    </vetalfa-section-title> -->
                    <vetalfa-section-title
                      prop="Algoritmo"
                      v-if="item && (profile == 1 || isDevelopment)"
                      class="ma-0 pa-0"
                    >
                      <v-textarea
                        auto-grow
                        rows="1"
                        type="text"
                        inputmode="decimal"
                        hide-details
                        class="my-5 mx-2"
                        light
                        dense
                        label="Algoritmo"
                        color="primary"
                        v-model="treeCsv"
                        outlined
                      ></v-textarea>
                      <v-row class="ma-0 pl-2">
                        <v-btn
                          :disabled="!treeCsv"
                          color="primary"
                          class="mb-2 ma-0 ml-2"
                          @click="setupTreeAlgorithmAsync(treeCsv)"
                        >
                          Gerar Algoritmo
                        </v-btn>
                        <v-checkbox
                          disabled
                          v-model="tree"
                          class="mb-2 ma-0 ml-2"
                          :label="
                            !!tree
                              ? 'Possui algoritmo'
                              : 'Nenhum algoritmo salvo'
                          "
                        ></v-checkbox>
                        <v-btn
                          :disabled="!tree"
                          color="primary"
                          class="mb-2 ma-0 ml-5"
                          @click="testTreeAlgorithm()"
                        >
                          Visualizar Algoritmo
                        </v-btn>
                      </v-row>
                    </vetalfa-section-title>
                    <vetalfa-section-title
                      prop="Exportar e importar TXT"
                      v-if="item && (profile == 1 || isDevelopment)"
                      class="ma-0 pa-0"
                    >
                      <v-btn
                        @click="exportTextContent"
                        right
                        class="ma-2 pa-2 text-none"
                        color="primary"
                      >
                        Exportar
                      </v-btn>
                      <v-btn
                        @click="importTextContent"
                        right
                        class="ma-2 pa-2 text-none"
                        color="primary"
                      >
                        Importar
                      </v-btn>
                      <v-textarea
                        auto-grow
                        rows="1"
                        type="text"
                        hide-details
                        class="my-5 mx-2"
                        light
                        dense
                        label="Texto"
                        color="primary"
                        v-model="textContent"
                        outlined
                      ></v-textarea>
                    </vetalfa-section-title>
                    <!-- <vetalfa-section-title
                      prop="Traduzir conteúdo"
                      v-if="item && (profile == 1 || isDevelopment)"
                      class="ma-0 pa-0"
                    >
                      <v-btn
                        @click="translateContent"
                        right
                        class="ma-2 pa-2 text-none"
                        color="primary"
                      >
                        Clique para Traduzir
                      </v-btn>
                    </vetalfa-section-title> -->
                  </vetalfa-dialog>
                </template>
                <span>Associar categorias e animais (filtros)</span>
              </v-tooltip>
            </v-col>
            <v-col v-if="item && subtopic && topic && configuration" cols="1">
              <v-tooltip bottom>
                <template
                  v-slot:activator="{ on: onTooltip, attrs: attrsTooltip }"
                >
                  <v-dialog max-width="500" v-model="subtopicsDialog">
                    <template
                      v-slot:activator="{ on: onDialog, attrs: attrsDialog }"
                    >
                      <v-btn
                        block
                        color="primary"
                        class="text-none"
                        v-bind="{ ...attrsTooltip, ...attrsDialog }"
                        v-on="{ ...onTooltip, ...onDialog }"
                      >
                        <v-icon>{{ mdiSitemap }}</v-icon>
                      </v-btn>
                    </template>
                    <v-card :height="400" max-width="500">
                      <vetalfa-card-title
                        class="mb-5"
                        :closable="true"
                        title="Associação de Subtópicos"
                        v-on:closeCard="subtopicsDialog = false"
                      ></vetalfa-card-title>
                      <v-card-text class="pa-4 mt-5">
                        <v-chip
                          :outlined="!item.active"
                          color="primary"
                          v-for="item in itemSubtopics"
                          class="mx-1"
                          :key="item.name"
                          @click="selectSubtopicForItem(item)"
                        >
                          {{ item.name }}
                        </v-chip>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                </template>
                <span>Associar subtópicos</span>
              </v-tooltip>
            </v-col>
            <v-col v-if="item && subtopic && topic && configuration" cols="1">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    block
                    @click="toggleReferencesModel(true)"
                    color="primary"
                    class="text-none"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>{{ mdiBookOpenVariant }}</v-icon>
                  </v-btn>
                </template>
                <span>Referências</span>
              </v-tooltip>
            </v-col>
            <v-col v-if="item && subtopic && topic && configuration" cols="1">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    block
                    @click="copySelect()"
                    color="primary"
                    class="text-none"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>{{ mdiContentCopy }}</v-icon>
                  </v-btn>
                </template>
                <span>Copiar conteúdo</span>
              </v-tooltip>
            </v-col>
            <v-col v-if="item && subtopic && topic && configuration" cols="1">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    block
                    @click="saveChangesAsync()"
                    color="primary"
                    class="text-none"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>{{ mdiContentSaveOutline }}</v-icon>
                  </v-btn>
                </template>
                <span>Salvar item</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="8" v-if="item && subtopic && topic && configuration">
        <v-card :height="`${editionRowHeight}px`">
          <v-container v-bind:style="editionRowContainerStyle">
            <section-management
              v-on:setSections="setSections"
              v-on:addReferencesToSection="addReferencesToSection"
              :sectionsArray="sections"
              ref="sectionManagement"
            ></section-management>
          </v-container>
        </v-card>
      </v-col>
      <v-col cols="4" v-if="item && subtopic && topic && configuration">
        <v-card class="ma-0 pa-0" :height="`${editionRowHeight}px`">
          <v-container
            class="ma-0 pa-0"
            v-bind:style="editionRowContainerStyle"
          >
            <vetalfa-general-tab
              :sections="sections"
              :references="references"
              topics
              class="ma-0 pa-0"
              adminMode
            ></vetalfa-general-tab>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <references-management
      :model="referencesModel"
      v-on:addReference="addReference"
      v-on:deleteReference="deleteReference"
      v-on:toggleReferencesModel="toggleReferencesModel"
      v-on:referencesSelection="referencesSelection"
      :references="references"
      :sectionReferences="sectionReferences"
    ></references-management>
    <v-dialog scrollable persistent v-model="topicsManagementModel">
      <v-card height="600px">
        <v-card-title class="ma-0 pa-0">
          <v-row class="ma-0 pa-0 mt-3" justify="start">
            <v-col cols="3" class="ma-0 pa-0"> </v-col>
            <v-col cols="6" class="ma-0 pa-0">
              <v-row
                justify="center"
                align="center"
                class="vetalfa-row ma-0 pa-0 px-4"
              >
                <p class="text-center vetalfa-dialog-title pt-1 pa-0 ma-0">
                  {{
                    copyMode ? "Seleção item para copiar" : "Gestão de Tópicos"
                  }}
                </p>
              </v-row>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="ma-0 pa-0 pa-4">
          <v-stepper v-model="topicsManagamentStepper">
            <v-stepper-header>
              <v-stepper-step :complete="topicsManagamentStepper > 1" step="1">
                Tópicos
              </v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="topicsManagamentStepper > 2" step="2">
                Subtópicos
              </v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step step="3"> Itens </v-stepper-step>
            </v-stepper-header>
            <v-stepper-items>
              <v-stepper-content class="ma-0 pa-0" step="1">
                <v-card height="450px">
                  <vetalfa-section-title prop="Selecione o tópico desejado:">
                    <v-autocomplete
                      :items="topics"
                      placeholder="Selecione ou digite para criar"
                      hide-details
                      chips
                      return-object
                      filled
                      item-text="name"
                      class="mx-2 my-5"
                      dense
                      outlined
                      :disabled="loading"
                      :loading="loading"
                      v-model="topic"
                      id="vetalfa-topics-management-topics"
                    >
                      <template v-slot:prepend-item>
                        <v-row
                          @click="addTopicAsync()"
                          class="
                            ma-0
                            pa-0
                            py-1
                            px-4
                            vetalfa-title vetalfa-pointer
                          "
                          align="center"
                        >
                          <v-icon color="primary" small class="pb-1 mr-2">{{
                            mdiPlus
                          }}</v-icon>
                          {{ _getLabel("TOPICS_MANAGEMENT_CLICK_TO_ADD") }}
                        </v-row>
                      </template>
                      <template v-slot:no-data>{{ "" }}</template>
                    </v-autocomplete>
                  </vetalfa-section-title>
                  <v-spacer></v-spacer>
                  <v-row class="ma-0 pa-0" align="end">
                    <v-spacer></v-spacer>
                    <v-col cols="3">
                      <v-btn
                        v-if="topic"
                        block
                        color="primary"
                        class="text-none"
                        @click="topicsManagamentStepper++"
                        :loading="loading"
                      >
                        Próximo passo
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>

              <v-stepper-content class="ma-0 pa-0" step="2">
                <v-card height="450px">
                  <vetalfa-section-title
                    v-if="topic"
                    :prop="`${topic.name} | Selecione o subtópico desejado:`"
                  >
                    <v-autocomplete
                      :items="topic.subtopics"
                      placeholder="Selecione ou digite para criar"
                      hide-details
                      return-object
                      filled
                      chips
                      item-text="name"
                      class="mx-2 my-5"
                      dense
                      outlined
                      v-model="subtopic"
                      :disabled="loading"
                      :loading="loading"
                      id="vetalfa-topics-management-subtopics"
                    >
                      <template v-slot:prepend-item>
                        <v-row
                          @click="addSubtopicAsync()"
                          class="
                            ma-0
                            pa-0
                            py-1
                            px-4
                            vetalfa-title vetalfa-pointer
                          "
                          align="center"
                        >
                          <v-icon color="primary" small class="pb-1 mr-2">{{
                            mdiPlus
                          }}</v-icon>
                          {{ _getLabel("TOPICS_MANAGEMENT_CLICK_TO_ADD") }}
                        </v-row>
                      </template>
                      <template v-slot:no-data>{{ "" }}</template>
                    </v-autocomplete>
                  </vetalfa-section-title>
                  <v-spacer></v-spacer>
                  <v-row class="ma-0 pa-0" align="end">
                    <v-col cols="3">
                      <v-btn
                        block
                        color="primary"
                        outlined
                        class="text-none"
                        @click="topicsManagamentStepper--"
                        v-show="!loading"
                      >
                        Voltar
                      </v-btn>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="3">
                      <v-btn
                        v-if="subtopic && (profile == 1 || isDevelopment)"
                        block
                        class="text-none red white--text"
                        :loading="loading"
                        @click="
                          changeSubtopicStatus({
                            id: subtopic.id,
                            available: false,
                          })
                        "
                      >
                        Remover disponibilidade
                      </v-btn>
                    </v-col>
                    <v-col cols="3">
                      <v-btn
                        v-if="subtopic && (profile == 1 || isDevelopment)"
                        block
                        class="text-none green white--text"
                        :loading="loading"
                        @click="
                          changeSubtopicStatus({
                            id: subtopic.id,
                            available: true,
                          })
                        "
                      >
                        Disponibilizar subtópico
                      </v-btn>
                    </v-col>
                    <v-col cols="3">
                      <v-btn
                        v-if="subtopic"
                        block
                        color="primary"
                        class="text-none"
                        @click="showItemsAsync()"
                        :loading="loading"
                      >
                        Próximo passo
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="3" class="ma-0 pa-0">
                <v-card height="450px">
                  <vetalfa-section-title
                    v-if="subtopic"
                    :prop="`${topic.name} | ${subtopic.name} | Selecione o item desejado:`"
                  >
                    <v-autocomplete
                      :items="items"
                      placeholder="Selecione ou digite para criar"
                      hide-details
                      return-object
                      filled
                      chips
                      item-text="name"
                      class="mx-2 my-5"
                      dense
                      outlined
                      v-model="item"
                      :disabled="loading"
                      :loading="loading"
                      id="vetalfa-topics-management-items"
                    >
                      <template v-slot:prepend-item>
                        <v-row
                          @click="addItemAsync()"
                          class="
                            ma-0
                            pa-0
                            py-1
                            px-4
                            vetalfa-title vetalfa-pointer
                          "
                          align="center"
                        >
                          <v-icon color="primary" small class="pb-1 mr-2">{{
                            mdiPlus
                          }}</v-icon>
                          {{ _getLabel("TOPICS_MANAGEMENT_CLICK_TO_ADD") }}
                        </v-row>
                      </template>
                      <template v-slot:no-data>{{ "" }}</template>
                    </v-autocomplete>
                  </vetalfa-section-title>
                  <v-spacer></v-spacer>
                  <v-row class="ma-0 pa-0" align="end">
                    <v-col cols="3">
                      <v-btn
                        block
                        color="primary"
                        outlined
                        class="text-none"
                        @click="topicsManagamentStepper--"
                        v-show="!loading"
                      >
                        Voltar
                      </v-btn>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="3">
                      <v-btn
                        v-if="item && (profile == 1 || isDevelopment)"
                        block
                        class="text-none red white--text"
                        :loading="loading"
                        @click="
                          changeItemStatus({ id: item.id, available: false })
                        "
                      >
                        Remover disponibilidade
                      </v-btn>
                    </v-col>
                    <v-col cols="3">
                      <v-btn
                        v-if="item && (profile == 1 || isDevelopment)"
                        block
                        class="text-none green white--text"
                        :loading="loading"
                        @click="
                          changeItemStatus({ id: item.id, available: true })
                        "
                      >
                        Aprovar e disponibilizar item
                      </v-btn>
                    </v-col>
                    <v-col cols="3">
                      <v-btn
                        v-if="item"
                        block
                        color="primary"
                        class="text-none"
                        :loading="loading"
                        @click="selectItemAsync()"
                      >
                        {{ copyMode ? "Copiar do item" : "Selecionar item" }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import SectionManagement from "@/components/management/SectionManagement.vue";
import ReferencesManagement from "@/components/management/ReferencesManagement.vue";
import {
  mdiPlus,
  mdiFileTree,
  mdiContentCopy,
  mdiContentSaveOutline,
  mdiBookOpenVariant,
  mdiSitemap,
  mdiFilterVariant,
} from "@mdi/js";
import labels from "@/constants/labels.js";
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  name: "TopicsManagement",
  components: {
    "section-management": SectionManagement,
    "references-management": ReferencesManagement,
  },
  methods: {
    ...mapActions("management", [
      "addTopic",
      "getTopics",
      "addSubtopic",
      "getSubtopicItems",
      "getItem",
      "addItem",
      "saveItemChanges",
      "loginManagement",
      "changeItemStatus",
      "changeSubtopicStatus",
      "setupTreeAlgorithm",
    ]),
    ...mapActions("general", ["showError", "routePathRedirect"]),
    ...mapMutations("management", ["setItemId", "setAlgorithm"]),
    exportTextContent() {
      this.textContent = "";
      this.sections.forEach((item) => {
        let ref = "",
          tempInput = "",
          refs = [],
          refIndex = 0;
        let input = item.text;
        for (let i = 0; i < input.length; i++) {
          if (
            (input.charAt(i) == "^" && input.charAt(i + 1) == "^") ||
            (input.charAt(i) == "^" && input.charAt(i - 1) == "^")
          ) {
            refIndex++;
          }
          if (refIndex > 0) {
            ref += input.charAt(i);
          } else {
            tempInput += input.charAt(i);
          }

          if (refIndex == 4) {
            refs.push(ref);
            ref = "";
            refIndex = 0;
          }
        }
        this.textContent += "\n";
        this.textContent += {
          0: "MZX",
          1: "TZX",
          2: "SZX",
          3: "IZX",
          4: "SIZX",
        }[item.style];
        this.textContent += "\n\n";
        this.textContent += `${tempInput} ${refs
          .join(" ")
          .split("^^")
          .join("RZX")} \n`;
      });
    },
    importTextContent() {
      let sections = [];
      let tempSection = {};
      this.textContent.split("\n").forEach((line) => {
        if (!line.trim()) {
          return;
        }
        let styles = {
          MZX: 0,
          TZX: 1,
          SZX: 2,
          IZX: 3,
          SIZX: 4,
        };
        if (typeof styles[line.trim()] === "number") {
          tempSection = { style: styles[line.trim()], text: "" };
        } else {
          tempSection["text"] = line.trim();
          sections.push(tempSection);
        }
      });
      this.sections = sections;
    },
    testTreeAlgorithm() {
      if (
        confirm(
          "Confirme que deseja visualizar o algoritmo, salve sua alterações nesta tela antes de proceder pois elas serão perdidas."
        )
      ) {
        this.setAlgorithm({
          id: this.item.id,
          references: this.references,
          sections: this.sections,
          categories: this.categories,
          topic_id: this.topic.id,
          animals: this.animals,
          contentPoints: this.contentPoints,
          tree: this.tree,
          synonyms: this.synonyms,
          name: this.item.name,
        });
        this.routePathRedirect({ path: "/item/" + this.item.id });
      }
    },
    setupTreeAlgorithmAsync: async function (val) {
      this.tree = await this.setupTreeAlgorithm({
        csv: val,
        sections: this.sections,
      });
    },
    translateContent: async function () {
      if (!this.translated) {
        alert(
          "Por favor, salve o item antes de traduzi-lo pela primeira vez e recarregue a página."
        );
        return;
      }
      if (confirm("Clique em OK para confirmar a tradução:")) {
        Object.keys(this.translated).forEach((key, index) => {
          this.sections[index].text = this.translated[key]["pt"];
        });
      }
    },
    selectSubtopicForItem(item) {
      if (item.disabled) {
        alert("O subtópico original não pode ser removido");
        return;
      }
      for (let subtopic of this.itemSubtopics) {
        if (subtopic.id == item.id) {
          subtopic.active = !subtopic.active;
        }
      }
    },
    copySelect() {
      this.previousItem = { ...this.item };
      this.previousTopic = { ...this.topic };
      this.previousSubtopic = { ...this.subtopic };
      this.copyMode = true;
      this.openTopicSelection();
    },
    addReferencesToSection({ index, references }) {
      this.sectionIndex = index;
      this.sectionReferences = references.sort((a, b) =>
        a.type < b.type || !a.type ? 1 : -1
      );
      this.toggleReferencesModel(true);
    },
    toggleReferencesModel(val) {
      this.referencesModel = val;
      if (!val) {
        this.sectionReferences = null;
      }
    },
    referencesSelection(args) {
      this.$refs.sectionManagement.referencesSelection({
        references: args,
        index: this.sectionIndex,
      });
    },
    setEditionRowSize() {
      const el = document.getElementById("topics-management-edition-row");
      if (!el) {
        setTimeout(this.setEditionRowSize, 100);
      } else {
        this.editionRowHeight = el.offsetHeight - 100;
      }
    },
    setSections(args) {
      this.sections = args;
    },
    addReference(reference) {
      this.deleteReference(reference.id);
      this.references.push(reference);
      this.references = this.references.sort((a, b) =>
        a.type < b.type || !a.type ? 1 : -1
      );
    },
    deleteReference(id) {
      this.references = this.references.filter((reference) => {
        return reference.id !== id;
      });
      this.$refs.sectionManagement.deleteReferences(id);
    },
    addTopicAsync: async function () {
      const name = this._getDocumentById(
        "vetalfa-topics-management-topics"
      ).value;
      if (name && confirm("Confirmar adição de um novo tópico?")) {
        const topic = await this.addTopic(name);
        if (topic) {
          this.topics.push(topic);
        }
      }
    },
    addSubtopicAsync: async function () {
      const name = this._getDocumentById(
        "vetalfa-topics-management-subtopics"
      ).value;
      if (name && confirm("Confirmar adição de um novo subtópico?")) {
        const subtopic = await this.addSubtopic({ name, topic: this.topic });
        if (subtopic) {
          this.topic.subtopics.push(subtopic);
        }
      }
    },
    showItemsAsync: async function () {
      this.subtopic["items"] = await this.getSubtopicItems({
        subtopic: this.subtopic,
      });
      if (this.subtopic["items"]) {
        this.items = this.subtopic.items;
        this.topicsManagamentStepper++;
      }
    },
    addItemAsync: async function () {
      const name = this._getDocumentById(
        "vetalfa-topics-management-items"
      ).value;
      if (name && confirm("Confirmar adição de um novo item?")) {
        const item = await this.addItem({ name, subtopic: this.subtopic });
        if (item) {
          this.items.push(item);
        }
      }
    },
    selectItemAsync: async function () {
      this.itemSubtopics = [];
      const itemDetails = await this.getItem(this.item.id);
      if (
        !!itemDetails.creator &&
        itemDetails.creator != "dimitri" &&
        itemDetails.creator != this.managementUser &&
        !this.isDevelopment &&
        this.profile != 1
      ) {
        this.showError(
          "Ops, desculpe. Você só pode visualizar itens criados por você ou padronizados pela equipe Vet Alfa."
        );
        return;
      }
      this.topic.subtopics.forEach((s) => {
        let itemSubtopic = { ...s };
        delete itemSubtopic["items"];
        itemSubtopic["disabled"] = false;
        itemSubtopic["active"] = false;
        if (itemSubtopic.id == itemDetails.subtopic_id) {
          itemSubtopic["disabled"] = true;
          itemSubtopic["active"] = true;
        } else if (
          itemDetails.subtopics &&
          itemDetails.subtopics.find((item) => {
            return item.id == s.id;
          })
        ) {
          itemSubtopic["active"] = true;
        }
        this.itemSubtopics.push(itemSubtopic);
      });
      if (itemDetails) {
        this.translated = itemDetails.translated;
        this.setSections(itemDetails.sections);
        this.references = itemDetails.references;
        this.categories = itemDetails.categories;
        this.animals = itemDetails.animals;
        this.contentPoints = itemDetails.contentPoints || {
          value: 0,
          description: "",
        };
        this.tree = itemDetails.tree;
        this.synonyms = itemDetails.synonyms || [];
        if (this.copyMode) {
          this.item = { ...this.previousItem };
          this.copyMode = false;
        } else {
          this.configuration = {
            item: this.item,
            topic: this.topic,
            subtopic: this.subtopic,
          };
        }
        this.setItemId(this.item.id);
        this.topicsManagementModel = false;
      }
    },
    openTopicSelection: async function () {
      if (
        !this.configuration ||
        confirm(
          "Deseja selecionar outros itens antes de salvar as alterações efetuadas? Dados não salvos serão perdidos."
        )
      ) {
        if (!!this.configuration) {
          return window.location.reload();
        }
        this.topics = await this.getTopics();
        if (this.topics) {
          this.topicsManagementModel = true;
        }
      }
    },
    saveChangesAsync: async function () {
      if (confirm("Confirmar e salvar as alterações dos dados?")) {
        let subtopics = [];
        for (const item of this.itemSubtopics) {
          if (item.active) {
            subtopics.push({ name: item.name, id: item.id });
          }
        }
        debugger;
        await this.saveItemChanges({
          id: this.item.id,
          references: this.references,
          sections: this.sections,
          categories: this.categories,
          animals: this.animals,
          contentPoints: this.contentPoints,
          tree: this.tree,
          synonyms: this.synonyms,
          subtopics,
          name: this.item.name,
        });
      }
    },
  },
  watch: {
    topicsManagementModel() {
      this.topicsManagamentStepper = 1;
    },
    topic() {
      this.subtopic = null;
      this.topic.subtopics = this._sortByProp(this.topic.subtopics, "name");
      this.item = null;
    },
    subtopic() {
      this.item = null;
    },
    managementToken(val) {
      if (val) {
        this.setEditionRowSize();
        window.addEventListener("resize", this.setEditionRowSize, true);
      }
    },
  },
  computed: {
    ...mapGetters("general", ["loading"]),
    ...mapGetters("management", [
      "managementToken",
      "profile",
      "managementUser",
    ]),
    editionRowContainerStyle() {
      return `overflow-y:scroll;height:${this.editionRowHeight}px`;
    },
    isDevelopment() {
      return process.env.NODE_ENV == "development";
    },
    topicName() {
      return this.previousTopic ? this.previousTopic.name : this.topic.name;
    },
    subtopicName() {
      return this.previousSubtopic
        ? this.previousSubtopic.name
        : this.subtopic.name;
    },
  },
  data() {
    return {
      textContent: "",
      editionRowHeight: 0,
      sections: [],
      references: [],
      referencesModel: false,
      sectionReferences: null,
      sectionIndex: null,
      topicsManagementModel: false,
      topicsManagamentStepper: 1,
      topics: [],
      items: [],
      topic: null,
      subtopic: null,
      item: null,
      configuration: null,
      labels,
      mdiPlus,
      categories: "",
      categoriesList: [],
      classesAndAnimalsModel: false,
      animals: [],
      mdiFileTree,
      mdiContentCopy,
      mdiContentSaveOutline,
      mdiBookOpenVariant,
      mdiSitemap,
      mdiFilterVariant,
      copyMode: false,
      previousItem: null,
      previousTopic: null,
      previousSubtopic: null,
      itemSubtopics: [],
      subtopicsDialog: false,
      translated: null,
      contentPoints: {
        value: 0,
        description: "",
      },
      tree: null,
      treeCsv: null,
      synonyms: [],
    };
  },
  mounted() {
    if (!this.isDevelopment) {
      this.loginManagement();
      window.onbeforeunload = function () {
        return "Are you sure";
      };
    } else {
      this.setEditionRowSize();
      window.addEventListener("resize", this.setEditionRowSize, true);
    }
  },
};
</script>